"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var general_1 = require("utils/general");
var AlertStyles = (0, styles_1.styled)(material_1.Alert, { shouldForwardProp: (0, general_1.omitProps)('size') })(function (_a) {
    var theme = _a.theme, size = _a.size;
    return (__assign(__assign({}, size === 'small' && {
        padding: theme.spacing(0.5, 2),
        '.MuiAlert-message, .MuiAlert-icon': {
            padding: theme.spacing(0.25, 0),
        },
    }), size === 'large' && {
        padding: theme.spacing(1, 2),
        '.MuiAlert-message, .MuiAlert-icon': {
            padding: theme.spacing(1, 0),
        },
    }));
});
var Alert = function (_a) {
    var title = _a.title, message = _a.message, actionButtonLabel = _a.actionButtonLabel, onClick = _a.onClick, _b = _a.size, size = _b === void 0 ? 'medium' : _b, props = __rest(_a, ["title", "message", "actionButtonLabel", "onClick", "size"]);
    return ((0, jsx_runtime_1.jsxs)(AlertStyles, __assign({ size: size, action: (actionButtonLabel && onClick) && ((0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: props.severity, size: "small", onClick: onClick }, { children: actionButtonLabel }))) }, props, { children: [title && (0, jsx_runtime_1.jsx)(material_1.AlertTitle, { children: title }), message] })));
};
exports.default = Alert;
